<template>
  <div id="viewPc">
    <div class="main_bg">
      <!-- KV -->
      <div class="banner">
        <img :src="workspace.imgurl" class="bannerBg" />
      </div>
      <!-- ID.4 X -->
      <div class="banner">
        <img :src="workspace1.imgurl" class="bannerBg" />
        <div class="main2-content">
          <div class="detail-right">
            <h2 class="detail-title" style="margin-top: -1rem">
              {{ workspace1.title }}
            </h2>
            <div class="detail-content">
              {{ workspace1.subtitle }}
            </div>
          </div>
        </div>
      </div>

      <!-- 车型素材 -->
      <div class="banner">
        <img :src="workspace2.imgurl" class="bannerBg" />
        <div class="main2-content">
          <div class="title" style="margin-top: 6rem">车型素材</div>
          <div class="detail-all">
            <div style="display: flex; justify-content: space-between">
              <div class="flex-chexing">
                <div class="layout-flex-chexing">
                  <div class="layout-flex-item" @click="handleList('waiguan')">
                    <img class="item-img" :src="workspace2.wurl" />
                    <div class="item-model" v-show="listKeyFn('waiguan')"></div>
                    <div class="item-model-title">外观</div>
                  </div>
                  <div class="layout-flex-item" @click="handleList('neishi')">
                    <img class="item-img" :src="workspace2.nurl" />
                    <div class="item-model" v-show="listKeyFn('neishi')"></div>
                    <div class="item-model-title">内饰</div>
                  </div>
                  <div class="layout-flex-item" @click="handleList('qita')">
                    <img class="item-img" :src="workspace2.qurl" />
                    <div class="item-model" v-show="listKeyFn('qita')"></div>
                    <div class="item-model-title">其他</div>
                  </div>
                  <div class="layout-flex-item" @click="handleList('shipin')">
                    <img class="item-img" :src="workspace2.surl" />
                    <div class="item-model" v-show="listKeyFn('shipin')"></div>
                    <div class="item-model-title">视频</div>
                  </div>
                </div>
              </div>
              <div class="carousel-chexing" :key="listKey">
                <el-carousel
                  indicator-position="none"
                  arrow="always"
                  style="width: 100%"
                >
                  <el-carousel-item
                    v-for="(item, index) in list"
                    :key="index"
                    @click.native="handleImg(item, index)"
                  >
                    <img class="carousel-item-img" :src="item" />
                    <img
                      class="videoPlay"
                      v-show="!listKeyFn('shipin')"
                      src="../../assets/id6/imgs/btn-video@2x.png"
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 交付 -->
      <div class="banner">
        <el-carousel arrow="never" style="width: 100%" height="96rem">
          <el-carousel-item
            v-for="(item, index) in workspace3.list"
            :key="index"
          >
            <img :src="item.imgurl" class="bannerBg" />
            <div class="main2-content">
              <div class="detail-left">
                <h2 class="detail-title">{{ item.title }} {{ item.title1 }}</h2>
                <div
                  style="height: 5px; width: 100px; margin-bottom: 10px"
                ></div>
                <div class="detail-content">
                  {{ item.subtitle }}
                </div>
                <div class="detail-btn" @click="handleDetail(item.url)">
                  查看详情
                </div>
              </div>
            </div>
          </el-carousel-item></el-carousel
        >
      </div>
      <!-- 大咖点评 -->
      <div class="banner daka">
        <div
          class="title"
          style="position: absolute; z-index: 999; width: 100%"
        >
          大咖点评
        </div>
        <el-carousel
          indicator-position="none"
          arrow="always"
          :autoplay="false"
          style="width: 100%"
          height="96rem"
        >
          <el-carousel-item
            v-for="(item, index) in workspace4.list"
            :key="index"
          >
            <img :src="item.imgurl" class="bannerBg" />
            <div class="main2-content">
              <div
                class="detail-left"
                style="
                  width: 60rem;
                  padding: 4rem;
                  background: #000000;
                  opacity: 0.6;
                  height: 30%;
                  position: absolute;
                "
              ></div>
              <div class="detail-left" style="width: 60rem; padding: 4rem">
                <h2 class="detail-title">
                  <img :src="item.title" />
                </h2>
                <div class="detail-content">
                  {{ item.subtitle }}
                </div>
                <div class="detail-btn" @click="handleDetail(item.url)">
                  查看原文
                </div>
              </div>
            </div>
          </el-carousel-item></el-carousel
        >
      </div>
      <!-- 媒体试驾 -->
      <div class="banner meiti">
        <img :src="workspace5.imgurl" class="bannerBg" />
        <div
          class="main2-content"
          style="width: calc(100% - 12rem); margin: 0px 6rem"
        >
          <div class="title">媒体试驾</div>
          <div class="detail-all">
            <el-carousel
              indicator-position="none"
              arrow="always"
              :autoplay="false"
              style="width: 100%"
            >
              <el-carousel-item
                v-for="(itemPC, indexPC) in workspace5.shipinPC"
                :key="indexPC"
              >
                <div class="layout-flex" style="margin: 0px 10rem">
                  <div
                    class="layout-flex-item"
                    v-for="(item, index) in itemPC"
                    :key="index"
                    @click="handleImg2(item, indexPC * 3 + index)"
                  >
                    <img class="carousel-item-img" :src="item" />
                    <img
                      class="videoPlay"
                      src="../../assets/id6/imgs/btn-video@2x.png"
                    />
                  </div>
                </div>
              </el-carousel-item>
              <el-carousel-item
                v-for="(itemPC, indexPC) in workspace5.shipinPC"
                :key="indexPC"
              >
                <div class="layout-flex" style="margin: 0px 10rem">
                  <div
                    class="layout-flex-item"
                    v-for="(item, index) in itemPC"
                    :key="index"
                    @click="handleImg2(item, indexPC * 3 + index)"
                  >
                    <img class="carousel-item-img" :src="item" />
                    <img
                      class="videoPlay"
                      src="../../assets/id6/imgs/btn-video@2x.png"
                    />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible">
      <el-carousel
        indicator-position="none"
        arrow="always"
        :autoplay="false"
        style="width: 100%"
        height="82rem"
        :initial-index="dialogIndex"
      >
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <img :src="item" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" v-if="dialogVisible2">
      <contentVideo2 :url="dialogVideo"></contentVideo2>
    </el-dialog>
  </div>
</template>

<script>
import contentVideo from "./components/contentVideo.vue";
import contentVideo2 from "./components/contentVideo2.vue";
import config from "./config";
export default {
  components: {
    contentVideo,
    contentVideo2,
  },
  data() {
    return {
      ...config,
      // 图片
      dialogVisible: false,
      // 视频
      dialogVisible2: false,
      dialogIndex: 0,
      dialogImg: "",
      dialogVideo: "",
      // 控制弹框视频
      dialogKey: "",
      listKey: "waiguan",
      list: config.workspace2.waiguan,
    };
  },
  mounted() {
    document.documentElement.style.fontSize =
      document.documentElement.clientWidth / 192 + "px";
  },
  destroyed() {
    document.documentElement.style.fontSize = "62.5%";
  },
  methods: {
    listKeyFn(val) {
      let bool = this.listKey === val;
      return !bool;
    },
    handleList(val) {
      this.listKey = val;
      this.list = this.workspace2[val];
    },
    // 车型素材-图片
    handleImg(val, index) {
      if (this.listKey === "shipin") {
        this.handleVideo(val, index);
      } else {
        this.dialogVisible = true;
        this.dialogIndex = index;
      }
    },
    // 车型素材-视频
    handleVideo(val, index) {
      this.dialogVisible2 = true;
      this.dialogVideo = this.workspace2.videourl[index];
    },
    // 媒体试驾
    handleImg2(val, index) {
      this.dialogVisible2 = true;
      this.dialogVideo = this.workspace5.videourl[index];
    },
    // 现场直击
    handleImg3(val, index) {
      this.dialogVisible = true;
    },
    handleDetail(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
#viewPc {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
}
/deep/.el-carousel__arrow {
  background-color: #000000;
  opacity: 0.6;
}
/deep/.el-carousel__button {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
}

// 弹框
/deep/.el-dialog {
  background: transparent;
  box-shadow: none;
  width: 115rem;
  height: 82rem;
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__headerbtn {
    top: 0px;
    right: 0px;
  }
  .el-dialog__close {
    color: #fff;
  }
}

//底纹
.main_bg {
  width: 100%;
  min-width: 1200px;
}

//背景图
.banner {
  position: relative;
  .bannerBg {
    width: 100%;
    display: block;
  }
}

// 布局
.main2-content {
  position: absolute;
  top: 0;
  height: 100%;
  width: calc(100% - 32rem);
  margin: 0px 16rem;
}

// 标题
.title {
  text-align: center;
  margin-top: 8rem;
  font-size: 30px;
  font-weight: 400;
  color: #ffffff;
}

// 布局全
.detail-all {
  position: absolute;
  width: 100%;
  color: #fff;
  z-index: 1;
  left: 0%;
  top: 50%;
  transform: translate(0%, -50%);
}
// 布局左
.detail-left {
  position: absolute;
  width: 86rem;
  color: #fff;
  z-index: 1;
  left: 0%;
  top: 50%;
  transform: translate(0%, -50%);
}
// 布局右
.detail-right {
  position: absolute;
  width: 86rem;
  color: #fff;
  z-index: 1;
  right: 0%;
  top: 50%;
  transform: translate(0%, -50%);
}

// 车型左边图
.flex-chexing {
  width: 70rem;
  .layout-flex-chexing {
    display: flex;
    justify-content: space-between;
    align-content: space-between;
    flex-wrap: wrap;
    height: 53rem;
    margin-top: 4rem;
    .layout-flex-item {
      width: 34rem;
      height: 25rem;
      position: relative;
      cursor: pointer;
      .item-img {
        width: 100%;
        height: 100%;
      }
      .item-model {
        position: absolute;
        background: #000000;
        opacity: 0.6;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .item-model-title {
        padding: 10px 30px;
        border-top: 1px solid;
        border-bottom: 1px solid;
        position: absolute;
        color: #ffffff;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

// 车型右边图
.carousel-chexing {
  width: 86rem;
  /deep/.el-carousel__container {
    height: 60rem;
  }
  .carousel-item-img {
    width: 100%;
    height: 60rem;
  }
}

// 大咖点评
.daka {
  /deep/.el-carousel__arrow--left {
    left: calc(6rem + 16px);
  }
  /deep/.el-carousel__arrow--right {
    right: calc(6rem + 16px);
  }
}

// 媒体试驾轮播图
.meiti {
  /deep/.el-carousel__container {
    height: 50rem;
  }
  .layout-flex {
    display: flex;
    justify-content: space-between;
    .layout-flex-item {
      width: 50rem;
      height: 48rem;
      position: relative;
    }
    .carousel-item-img {
      width: 100%;
      height: 48rem;
    }
  }
}

.videoPlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8rem;
  height: 8rem;
}

// 详情标题
.detail-title {
}
// 详情内容
.detail-content {
  line-height: 28px;
}
// 详情按钮
.detail-btn {
  display: inline-block;
  border: 1px solid #f6f6f6;
  padding: 5px 10px;
  margin-top: 20px;
  cursor: pointer;
}

@media screen and (min-width: 1500px) {
  .title {
    font-size: 48px;
  }
  .detail-title {
    font-size: 28px;
  }
  // 详情内容
  .detail-content {
    font-size: 18px;
    line-height: 34px;
  }
  // 详情按钮
  .detail-btn {
    font-size: 18px;
  }
}
</style>
